import { motion } from "framer-motion";
import { Layout } from "@/components/Layout";

export default function Documentation() {
  return (
    <Layout
      title="Documentation | Cryptfluencers NFT Collection"
      description="Learn how to mint and manage your Cryptfluencer NFTs on Base, PulseChain, and Chia blockchains. Complete documentation and guides for the Cryptfluencers NFT collection."
      image="/banner.png"
    >
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-pixel mb-12 text-[#9333EA]">Documentation</h1>
        
        <div className="space-y-12 text-base">
          <section className="rounded-lg p-6 border border-gray-800">
            <h2 className="text-2xl font-pixel mb-4 text-[#9333EA]">Getting Started</h2>
            <p className="text-base text-gray-400">
              Welcome to the Cryptfluencers documentation. Here you'll find everything you need to know about minting and managing your Cryptfluencer NFTs.
            </p>
          </section>

          <section className="rounded-lg p-6 border border-gray-800">
            <h2 className="text-2xl font-pixel mb-4 text-[#9333EA]">Supported Chains</h2>
            <div className="space-y-4">
              <p className="text-base text-gray-400">Cryptfluencers are available on three different blockchains:</p>
              <ul className="grid gap-4 sm:grid-cols-3 text-base text-gray-400">
                <li className="p-4 rounded border border-gray-800">
                  Base - The Ethereum L2 built for social applications
                </li>
                <li className="p-4 rounded border border-gray-800">
                  PulseChain - The energy-efficient fork of Ethereum
                </li>
                <li className="p-4 rounded border border-gray-800">
                  Chia - The eco-friendly blockchain
                </li>
              </ul>
            </div>
          </section>

          <section className="rounded-lg p-6 border border-gray-800">
            <h2 className="text-2xl font-pixel mb-4 text-[#9333EA]">How to Mint</h2>
            <div className="space-y-6">
              <p className="text-base text-gray-400">The minting process differs depending on your chosen blockchain:</p>
              
              <div className="grid gap-6 sm:grid-cols-2">
                <div className="p-4 rounded border border-gray-800">
                  <h3 className="text-xl font-pixel mb-4 text-[#9333EA]">For Base & PulseChain Users (EVM):</h3>
                  <ol className="list-decimal list-inside space-y-2 text-base text-gray-400">
                    <li>Connect your wallet</li>
                    <li>Choose your preferred blockchain (Base or PulseChain)</li>
                    <li>Select the number of NFTs to mint</li>
                    <li>Confirm the transaction in your wallet</li>
                    <li>Wait for the transaction to complete</li>
                  </ol>
                </div>

                <div className="p-4 rounded border border-gray-800">
                  <h3 className="text-xl font-pixel mb-4 text-[#9333EA]">For Chia Users:</h3>
                  <ol className="list-decimal list-inside space-y-2 text-base text-gray-400">
                    <li>Visit the <a href="https://mintgarden.io/collections/cryptfluencers-col1etvtg9y9xj0tq57nz25grk5d4la5j2v85zyff0j5hxpn5kt7zdzst8wmvc?tab=mint" className="text-[#9333EA] hover:underline">Cryptfluencers Collection on MintGarden</a></li>
                    <li>Choose from any of the 6 available characters</li>
                    <li>Complete the minting process to receive your character with random traits</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="rounded-lg p-6 border border-gray-800">
            <h2 className="text-2xl font-pixel mb-4 text-[#9333EA]">Smart Contracts</h2>
            <div className="space-y-4">
              <p className="text-base text-gray-400">Our smart contracts are deployed at the following addresses:</p>
              <div className="grid gap-4 sm:grid-cols-1">
                <ul className="list-none space-y-4 text-base text-gray-400">
                  <li className="p-4 rounded border border-gray-800 break-all">
                    <span className="block mb-2">Base:</span>
                    0x07e9324b757F1846a1c4f17832757eb64D6Eb6aD
                  </li>
                  <li className="p-4 rounded border border-gray-800 break-all">
                    <span className="block mb-2">PulseChain:</span>
                    0xAD010CA83aCF225b4D11109ef925f120A37de7e9
                  </li>
                  <li className="p-4 rounded border border-gray-800 break-all">
                    <span className="block mb-2">Chia Collection ID:</span>
                    col1etvtg9y9xj0tq57nz25grk5d4la5j2v85zyff0j5hxpn5kt7zdzst8wmvc
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
} 